module.exports = __webpack_public_path__ + "img/work_from_office5.656bdc23.png";